<template>
  <div class="flex justify-between pt-10px pb-10px title-w relative">
    <!-- <span class="b text-24px text-white">趋势查看</span>
    <div>
      <span class="el-icon-minus cur-pointer icon_hover" @click="toggleSmallDialog('shrink')">
      </span>
      <span v-if="showMaxIcon" class="iconfont icon-fullscreen cur-pointer icon_hover ml-10px" @click="toggleScreen">
      </span>
      <span
        class="el-dialog__close el-icon el-icon-close text-white cursor-pointer ml-10px"
        @click="closeDialog"
      >
      </span>
    </div> -->
    <CardTitle :title="'趋势查看'" :cardType="'horizontal'"></CardTitle>
    <div class="absolute top-24px right-14px">
      <span
        class="el-dialog__close el-icon el-icon-close dialog-close cursor-pointer ml-10px text-24px"
        @click="closeDialog"
      >
      </span>
    </div>
  </div>
</template>

<script type="text/babel">
import CardTitle from '@/components/cockpit/CardTitle'

export default {
  name: 'trendview-dialog-title',
  components: {
    CardTitle
  },
  props: {
    showMaxIcon: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    // 小窗化
    toggleSmallDialog(type) {
      this.$emit('on-toggle', type)
    },
    // 最大化
    toggleScreen() {
      this.$emit('on-fullscreen')
    },
    // 关闭
    async closeDialog() {
      this.$emit('on-close')
    },
  },
}
</script>
<style scoped lang="scss">
.dialog-close {
  color: var(--dialogCloseBg);
}
</style>
